import { MaterialIcon } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { ButtonGroup } from 'baseui/button-group';
import { Polygon } from 'geojson';
import { useRecoilState } from 'recoil';
import { DRAW_MODE_CIRCLE, DRAW_MODE_POLYGON, DRAW_MODE_RECTANGLE } from '../../../constants/map';
import { useStyles } from '../../../hooks/useStyles';
import { mapDrawModeState } from '../../../storage/map';

type Props = Readonly<{
  polygon?: Polygon;
  onUpdatePolygon: (newPolygon?: Polygon) => void;
}>;

export function CoreMapDrawOptions({ polygon, onUpdatePolygon }: Props) {
  const { theme, css } = useStyles();
  const [drawMode, setDrawMode] = useRecoilState(mapDrawModeState);

  const onDrawChange = (_event: any, index: number) => {
    if (index === 0) {
      setDrawMode(DRAW_MODE_POLYGON);
    } else if (index === 1) {
      setDrawMode(DRAW_MODE_CIRCLE);
    } else if (index === 2) {
      setDrawMode(DRAW_MODE_RECTANGLE);
    } else if (index === 3) {
      onUpdatePolygon(undefined);
      setDrawMode(DRAW_MODE_POLYGON);
    }
  };

  const getSelectedDrawMode = () => {
    if (drawMode === DRAW_MODE_POLYGON) {
      return 0;
    }
    if (drawMode === DRAW_MODE_CIRCLE) {
      return 1;
    }
    if (drawMode === DRAW_MODE_RECTANGLE) {
      return 2;
    }
  };

  const onResetFence = () => {
    onUpdatePolygon(polygon);
    setDrawMode(DRAW_MODE_POLYGON);
  };

  return (
    <>
      <span
        className={css({
          position: 'fixed',
          top: '50%',
          right: theme.sizing.scale500,
          transform: 'translateY(-50%)',
          padding: '2px',
          background: theme.colors.backgroundPrimary,
          borderRadius: '6px',
          boxShadow: 'rgba(0, 0, 0, 0.3) 0px 1px 4px -1px',
          lineHeight: 1,
          cursor: 'pointer',
        })}
      >
        <ButtonGroup
          mode={'radio'}
          selected={getSelectedDrawMode()}
          size="mini"
          onClick={onDrawChange}
          shape="square"
          kind="tertiary"
          overrides={{
            Root: {
              style: {
                flexDirection: 'column',
                gap: theme.sizing.scale0,
              },
            },
          }}
        >
          <Button>
            <MaterialIcon name="polyline" />
          </Button>
          <Button>
            <MaterialIcon name="circle" />
          </Button>
          <Button>
            <MaterialIcon name="square" />
          </Button>
          <Button>
            <MaterialIcon name="delete" />
          </Button>
        </ButtonGroup>
      </span>
      <span
        className={css({
          position: 'fixed',
          top: '62%',
          right: theme.sizing.scale500,
          transform: 'translateY(-50%)',
          padding: '2px',
          background: theme.colors.backgroundPrimary,
          borderRadius: '6px',
          boxShadow: 'rgba(0, 0, 0, 0.3) 0px 1px 4px -1px',
          lineHeight: 1,
          cursor: 'pointer',
        })}
      >
        <Button
          size="mini"
          shape="square"
          kind="tertiary"
          onClick={onResetFence}
        >
          <MaterialIcon name="refresh" />
        </Button>
      </span>
    </>
  );
}

export default CoreMapDrawOptions;
